import { render } from "./IconCalendarPlus.vue?vue&type=template&id=0a2c5ca7"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCalendarPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a2c5ca7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a2c5ca7', __exports__)) {
    api.reload('0a2c5ca7', __exports__)
  }
  
  module.hot.accept("./IconCalendarPlus.vue?vue&type=template&id=0a2c5ca7", () => {
    api.rerender('0a2c5ca7', render)
  })

}


export default __exports__